import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ServicesAgentsModule } from 'app/services/agents/services-agents.module';
import { SharedModule } from 'app/shared.module';
import { DataVisualizationSharedModule } from 'app/shared/components/data-visualization/data-visualization-shared.module';
import { TestDataAgentSSEModule } from 'app/test/components/data-agent-sse/test-data-agent-sse.module';

import { AiChatWrapperComponent } from './ai-chat-wrapper.component';
import { ChatInputComponent } from './components/chat-input/chat-input.component';
import { InsightSuggestionCardComponent } from './components/insights-suggestions/insight-suggestion-card.component';
import { InsightsSuggestionsContainerComponent } from './components/insights-suggestions/insights-suggestions-container.component';
import { ReasoningHistoryModalComponent } from './components/reasoning-history/reasoning-history-modal.component';
import { ChatSessionHistoryMenuComponent } from './chat-session-history-menu.component';
import { DatabricksChatContentComponent } from './databricks-chat-content.component';
import { StreamingChatContentComponent } from './streaming-chat-content.component';

@NgModule({
  declarations: [
    AiChatWrapperComponent,
    DatabricksChatContentComponent,
    ChatInputComponent,
    StreamingChatContentComponent,
    InsightsSuggestionsContainerComponent,
    InsightSuggestionCardComponent,
    ReasoningHistoryModalComponent,
    ChatSessionHistoryMenuComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    FlexLayoutModule,
    MatButtonModule,
    MatChipsModule,
    MatDialogModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatTooltipModule,
    SharedModule,
    ServicesAgentsModule,
    DataVisualizationSharedModule,
    TestDataAgentSSEModule,
  ],
  exports: [AiChatWrapperComponent, DatabricksChatContentComponent, StreamingChatContentComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AiChatFeatureModule {}
